var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":_vm.$vuetify.breakpoint.smAndDown ? 'slide-fade-down' : 'slide-fade',"appear":""}},[_c('create-address-form',{attrs:{"is-submitting":_vm.isSubmitting},on:{"formSubmitted":_vm.formSubmitHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }